import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['input', 'cancelButton']
  static classes = ['cancelable']

  focus() {
    this.inputTarget.focus()
  }

  toggleCancelable() {
    (this.inputTarget.value !== '') ? this.#enableCancelable() : this.#disableCancelable()
  }

  disableCancelableOnBlur({ relatedTarget }) {
    if (relatedTarget && this.element.contains(relatedTarget)) return

    this.#disableCancelable()
  }

  cancel() {
    this.inputTarget.value = ''
    this.dispatchInputEvent()
    this.focus()
  }

  dispatchInputEvent() {
    this.dispatch('input', { detail: { value: this.inputTarget.value } })
  }

  dispatchFocusEvent() {
    this.dispatch('focus')
  }

  #enableCancelable() {
    this.element.classList.add(this.cancelableClass)
  }

  #disableCancelable() {
    this.element.classList.remove(this.cancelableClass)
  }
}
